import { useDisclosure, Button, ModalOverlay, ModalContent, ModalBody, ModalCloseButton, Image, Modal, ModalFooter, Text, Heading, Center, Box, Input, useToast, } from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom"
import { FontFree_single_data } from '../FontFree_Data/FontFree_data.js'
import { useState } from "react"
import { Login } from "../../Components/Login/Login.jsx";
import { Register } from '../../Components/Register/Register.jsx';


export const Project = () => {
    const personal = JSON.parse(localStorage.getItem('personal')) || {};
    const { isOpen, onOpen, onClose } = useDisclosure();
    const navigate = useNavigate()
    const { id } = useParams();
    const [imgC, setImgC] = useState(0)
    const theme_color = '#4527A0'


    return (
        <Box>
            <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} p={'10px 20px'}>
                <Box cursor={'pointer'} onClick={() => navigate('/FontFree')} display={'flex'} gap={'7px'}>
                    <Text fontSize={'30px'} fontWeight={'medium'}>|| Font</Text>
                    <Text fontSize={'30px'} fontWeight={'medium'} color={'blue.300'}>Free</Text>
                </Box>
                <Box>
                    {personal['token'] ?
                        <Box display={'flex'} gap={'5px'}>
                            <Text color={'blue.300'} fontWeight={'medium'}>Hi,</Text>
                            <Text>{personal['userName'] && personal['userName'].split(' ')[0]}</Text>
                        </Box> :
                        <Box display={'flex'} gap={'10px'}>
                            <Box cursor={'pointer'} color={'grey'} fontSize={['17px', '18px', '20px']} fontWeight={'medium'}><Login prop={'Font_Free'} /></Box>
                            <Box cursor={'pointer'} color={'blue.300'} fontSize={['17px', '18px', '20px']} fontWeight={'medium'}><Register prop={'Font_Free'} /></Box>
                        </Box>
                    }
                </Box>
            </Box>

            <Box>
                {/* content */}
                {FontFree_single_data[id] && <Box w={['90%']} m={'auto'}>
                    <Box m={'1cm auto'} display={'flex'} flexDirection={['column', 'column', 'column', 'row-reverse']} justifyContent={'space-between'}>
                        <Box p={'10px'} w={['100%', '100%', '100%', '40%']}>
                            <Image cursor={'pointer'} onClick={() => onOpen()} borderRadius={'10px'} w={'100%'} h={'400px'} src={FontFree_single_data[id]['image'][imgC]} />
                            {FontFree_single_data[id]['responsive'] &&
                                <Box display={'flex'} gap={'10px'} m={'10px 0'}>
                                    <Button onClick={() => setImgC(0)} bg={theme_color} color={'white'} w={'100%'}>Desktop</Button>
                                    <Button onClick={() => setImgC(1)} bg={theme_color} color={'white'} w={'100%'}>Tab</Button>
                                    <Button onClick={() => setImgC(2)} bg={theme_color} color={'white'} w={'100%'}>Mobile</Button>
                                </Box>
                            }
                        </Box>

                        <Box p={'10px'} w={['100%', '100%', '100%', '60%']} display={'flex'} flexDirection={'column'} justifyContent={'space-between'}>
                            <Box>
                                <Box display={'flex'} alignItems={'center'} gap={'20px'}>
                                    <Text fontSize={'35px'} fontWeight={'bold'} color={'#424242'}>{FontFree_single_data[id]['title']}</Text>
                                    <a href="https://images.pexels.com/photos/235986/pexels-photo-235986.jpeg?auto=compress&cs=tinysrgb&w=600" download>
                                        <Image mr={'15px'} cursor={'pointer'} w='40px' h={'40px'} boxShadow={'rgba(0, 0, 0, 0.35) 0px 5px 15px'} borderRadius={'50%'} src={'https://cdn-icons-png.flaticon.com/128/9153/9153957.png'} alt='download' />
                                    </a>
                                </Box>
                                <Text fontSize={['18px']} m={'15px auto'} fontWeight={'medium'} color={'#616161'}>{FontFree_single_data[id]['description']}</Text>
                                <Box display={'flex'} gap={'10px'}>
                                    {FontFree_single_data[id]['language'] && FontFree_single_data[id]['language']?.map((ele, index) => (
                                        <Text color={ele == 'HTML' && 'orange' || ele == 'CSS' && 'blue.400' || ele == 'JS' && '#00C853'} fontSize={'16px'} fontWeight={'medium'} key={index}>{ele}</Text>
                                    ))}
                                </Box>
                            </Box>

                            <Box display={'flex'} flexDirection={'column'} gap={'15px'} m={'15px 0'}>
                                <Button w={['100%', '80%', '70%']} h={'50px'} bg={theme_color} color={'white'}>Download Project</Button>
                                <Button w={['100%', '80%', '70%']} h={'50px'} bg={theme_color} color={'white'}>Submit Project</Button>
                            </Box>

                        </Box>

                    </Box>
                    {/* Project */}
                    <Box m={'1cm auto'} display={'flex'} flexDirection={['column', 'column', 'row']} gap={'10px'}>
                        <Box w={['100%', '100%', '60%']} boxShadow={'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px'} borderRadius={'10px'} p={'10px'}>
                            <Heading m={'10px 0 20px 10px'} fontSize={['20px', '25px', '28px']} color={'grey'} fontWeight={'medium'}>Description</Heading>

                            {FontFree_single_data[id]['project'] && FontFree_single_data[id]['project']?.map((ele, index) => (
                                <Box key={index} w={'95%'} m={'auto'}>
                                    {ele['heading'] && <Text m={'10px'} fontSize={'25px'} fontWeight={'medium'}>{ele['heading']}</Text>}
                                    {ele['image'] && <Box><Image borderRadius={'10px'} w={['100%','80%','70%','50%']} src={ele['image']} alt={index} /></Box>}
                                    <Box m={'15px'}>
                                        <ul>
                                            {ele['list'] && ele['list']?.map((ele, index) => (
                                                <li style={{ fontSize: '17px' }} key={index}>{ele}</li>
                                            ))}
                                        </ul>
                                    </Box>
                                </Box>
                            ))}
                        </Box>

                        <Box w={['100%', '100%', '40%']} gap={'10px'} display={'flex'} flexDirection={'column'}>
                            <Box w={'100%'} boxShadow={'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px'} borderRadius={'10px'} p={'15px'}>
                                <Text fontSize={'20px'} fontWeight={'medium'} color={theme_color}>{FontFree_single_data[id]['title']}</Text>
                                <Box m={'15px'}>
                                    <ul>
                                        {FontFree_single_data[id]['responsive'] && <li style={{ fontSize: '17px' }}>The page should be Responsive in all the devices</li>}
                                        <li style={{ fontSize: '17px' }}>The page should be Responsive in all the devices</li>
                                        <li style={{ fontSize: '17px' }}>All the text will present in the downloaded file</li>
                                        <li style={{ fontSize: '17px' }}>You can find the Image in "assets" folder</li>
                                        <li style={{ fontSize: '17px' }}>Read the readme file for clear understanding</li>
                                    </ul>
                                </Box>
                            </Box>

                            <Box w={'100%'} boxShadow={'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px'} borderRadius={'10px'} p={'15px'}>
                                <Text fontSize={'20px'} fontWeight={'medium'} color={theme_color}>Helping Website</Text>
                                <Box m={'15px 0'}>
                                    <ul>
                                        <li style={{ fontSize: '17px', display: 'flex', gap: '10px' }}>
                                            <p>Color Metrial</p>
                                            <a target="_blank" style={{ color: '#03A9F4' }} href="https://artkorner.vercel.app/ColorMaterial">( Link )</a>
                                        </li>
                                        <li style={{ fontSize: '17px', display: 'flex', gap: '10px' }}>
                                            <p>Box Shadow </p>
                                            <a target="_blank" style={{ color: '#03A9F4' }} href="https://artkorner.vercel.app/Box-Shadow">( Link )</a>
                                        </li>

                                        <li style={{ fontSize: '17px', display: 'flex', gap: '10px' }}>
                                            <p>Gradients color</p>
                                            <a target="_blank" style={{ color: '#03A9F4' }} href="https://artkorner.vercel.app/GradientMaker">( Link )</a>
                                        </li>
                                    </ul>
                                </Box>
                            </Box>
                        </Box>

                    </Box>

                </Box>
                }
            </Box>

            <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent bg={'#212121'} maxW={['95%', '80%', '60%', '50%', '50%', '40%']} pt={'10px'} pb={'10px'}>
                    {/* <Heading fontSize={'30px'} fontWeight={'medium'} m={'15px auto'}>Font Free</Heading> */}
                    <ModalCloseButton color={'white'} fontWeight={'bold'} />



                    <ModalBody>
                        <Image borderRadius={'10px'} w={'100%'} src={FontFree_single_data[id]['image'][imgC]} />
                    </ModalBody>

                </ModalContent>
            </Modal>
        </Box>
    )
}